import { render, staticRenderFns } from "./BoSearch.vue?vue&type=template&id=5d50ff13"
import script from "./BoSearch.vue?vue&type=script&lang=js"
export * from "./BoSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports